<template>
  <div>
    <div class="query-container space-between">
      <div>
        <el-form size="small" :inline="true">
          <el-form-item label="统计时间：">
            <el-date-picker
              @change="query"
              value-format="yyyy-MM-dd"
              v-model="param.date"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button style="width: 100px; margin-right: 20px" type="primary" @click="query"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-button
          type="success"
          size="small"
          @click="exportReport"
          :disabled="!param.date || tableData.length === 0"
        >
          导出报告
        </el-button>
      </div>
    </div>

    <div>
      <!-- 质检报告内容区域 -->
      <div class="report-container">
        <el-table :data="tableData" stripe border max-height="650" style="width: 100%">
          <el-table-column label="序号" type="index" width="50" fixed="left"></el-table-column>

          <el-table-column prop="type" label="质检类型" width="100" fixed="left">
            <template slot-scope="scope">
              <span>{{ scope.row.type }}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="checkItems"
            label="质检项"
            width="300"
            fixed="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <LongTextTooltip :text="scope.row.checkItems" :max-length="30" />
            </template>
          </el-table-column>

          <el-table-column prop="driverNos" label="司机编号" width="300" show-overflow-tooltip>
            <template slot-scope="scope">
              <LongTextTooltip :text="scope.row.driverNos" :max-length="30" />
            </template>
          </el-table-column>

          <el-table-column
            prop="checkCount"
            label="检查次数"
            width="120"
            align="center"
          ></el-table-column>

          <el-table-column
            prop="checkRate"
            label="检查率"
            width="100"
            align="center"
            sortable
          ></el-table-column>

          <el-table-column
            prop="needImproveCount"
            label="问题数量"
            width="120"
            align="center"
            sortable
          ></el-table-column>

          <el-table-column
            prop="needImproveRate"
            label="问题率"
            width="120"
            align="center"
            sortable
          ></el-table-column>

          <el-table-column prop="remarks" label="备注" min-width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              <LongTextTooltip :text="scope.row.remarks || '-'" :max-length="30" />
            </template>
          </el-table-column>

          <el-table-column label="明细" width="100" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="toggleDetail(scope.row)"
                v-if="scope.row.detailList && scope.row.detailList.length > 0"
              >
                {{ scope.row.showDetail ? "收起" : "展开" }}({{ scope.row.detailList.length }})
              </el-button>
              <span v-else class="text-muted">-</span>
            </template>
          </el-table-column>
        </el-table>

        <!-- 明细表格 -->
        <template v-for="(row, index) in tableData">
          <div
            v-if="row.showDetail && row.detailList && row.detailList.length > 0"
            :key="'detail-' + index"
            class="detail-container"
          >
            <div class="detail-header">
              <span class="detail-title">{{ row.checkItems }} - 明细列表</span>
            </div>
            <el-table :data="row.detailList" stripe border size="small" style="width: 100%">
              <el-table-column label="序号" type="index" width="50"></el-table-column>
              <el-table-column prop="driverNo" label="司机编号" width="120"></el-table-column>
              <el-table-column
                prop="checkItem"
                label="质检项"
                width="150"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column prop="result" label="结果" width="100" align="center">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.result === '罚单' ? 'danger' : 'warning'" size="small">
                    {{ scope.row.result }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="totalTimes"
                label="累计次数"
                width="100"
                align="center"
              ></el-table-column>
            </el-table>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { getDailyQcSummary } from "@/api";
import { DateUtil } from "@/util";
import LongTextTooltip from "./LongTextTooltip";
import Router from "@/route";

export default {
  components: {
    LongTextTooltip
  },
  props: {},
  created() {
    // 初始化日期为今天
    this.query();
  },
  mounted() {},
  watch: {},
  computed: {},
  data() {
    return {
      param: {
        date: DateUtil.getDayStr(0)
      },
      tableData: []
    };
  },
  methods: {
    query() {
      if (!this.param.date) {
        this.$message.warning("请选择日期");
        return;
      }
      getDailyQcSummary(this.param.date)
        .then((res) => {
          const dataList = res.data || [];
          // 为每行数据添加 showDetail 属性，用于控制明细展开/收起
          this.tableData = dataList.map((item) => ({
            ...item,
            showDetail: false
          }));
        })
        .catch((err) => {
          console.error(err);
          this.$message.error("查询失败");
        });
    },
    toggleDetail(row) {
      this.$set(row, "showDetail", !row.showDetail);
    },
    exportReport() {
      if (!this.param.date) {
        this.$message.warning("请先选择日期");
        return;
      }
      if (this.tableData.length === 0) {
        this.$message.warning("暂无数据可导出");
        return;
      }
      const { href } = Router.resolve({
        path: "/qc/report/print",
        query: { date: this.param.date }
      });
      window.open(href, "_blank");
    }
  }
};
</script>
<style lang="less" scoped>
.query-container {
  margin-bottom: 20px;
}

.report-container {
  margin-top: 20px;
}

.text-muted {
  color: #909399;
}

.detail-container {
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;

  .detail-header {
    margin-bottom: 15px;

    .detail-title {
      font-size: 14px;
      font-weight: 600;
      color: #303133;
    }
  }
}
</style>
